import { render, staticRenderFns } from "./emojiPicker.vue?vue&type=template&id=06673004&"
import script from "./emojiPicker.vue?vue&type=script&lang=js&"
export * from "./emojiPicker.vue?vue&type=script&lang=js&"
import style0 from "./emojiPicker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports